<ng-container *ngIf="eligible">
    <div class="dip-card">
        <!-- Monto: lo cotiza el servidor. Es el que va a debitar el banco. -->
        <div class="dip-amount" *ngIf="!quoteError">
            <div class="dip-amount__loading" *ngIf="loadingQuote">
                <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                Calculando el monto…
            </div>
            <ng-container *ngIf="!loadingQuote && quote">
                <div class="dip-amount__ves">{{ amountVES | number : '1.2-2' }} Bs</div>
                <div class="dip-amount__usd">
                    {{ amountUSD | currency : 'USD' : 'symbol' : '1.2-2' }}
                    <span class="dip-amount__rate">· Tasa BCV {{ exchangeRateBCV | number : '1.2-2' }}</span>
                </div>
                <div class="dip-amount__note" *ngIf="quote.isPlanOnlyChange">
                    Cambio de plan por los {{ quote.planOnlyMonths }} {{ quote.planOnlyMonths === 1 ? 'mes' : 'meses' }} que te quedan del ciclo.
                </div>
            </ng-container>
        </div>

        <div class="dip-alert dip-alert--danger" *ngIf="quoteError">{{ quoteError }}</div>

        <div class="dip-alert dip-alert--warning" *ngIf="billAlreadyReported && step === 'account'">
            Ya reportaste un pago de esta factura y lo estamos verificando. Si pagas por aquí, se cobrará de nuevo.
        </div>

        <!-- Paso 1: con qué cuenta paga -->
        <ng-container *ngIf="step === 'account'">
            <div class="dip-accounts" *ngIf="accounts.length">
                <div class="dip-label">Paga con</div>
                <button type="button" class="dip-account" *ngFor="let account of accounts" [class.dip-account--active]="selectedAccountId === account.id" (click)="selectAccount(account.id)">
                    <span class="dip-account__icon"><fa-icon [icon]="['fas', 'mobile-screen-button']"></fa-icon></span>
                    <span class="dip-account__info">
                        <span class="dip-account__title">{{ accountBank(account) }}</span>
                        <!-- Teléfono y cédula son los datos con los que el cliente
                             reconoce SU cuenta: van juntos y con el mismo peso que
                             el banco, no como pista secundaria. -->
                        <span class="dip-account__data">{{ account.phone }} · {{ account.cedula }}</span>
                    </span>
                </button>
                <button type="button" class="dip-account" [class.dip-account--active]="!usingSavedAccount" (click)="selectAccount('')">
                    <span class="dip-account__icon"><fa-icon [icon]="['fas', 'plus']"></fa-icon></span>
                    <span class="dip-account__info">
                        <span class="dip-account__title">Usar otra cuenta</span>
                        <span class="dip-account__hint">Otro banco o teléfono de pago móvil</span>
                    </span>
                </button>
            </div>

            <!-- Cuenta nueva -->
            <form [formGroup]="accountForm" *ngIf="!usingSavedAccount" class="dip-form">
                <div class="dip-alert dip-alert--danger" *ngIf="banksUnavailable">No pudimos cargar la lista de bancos. Vuelve a intentarlo en unos minutos.</div>

                <div class="dip-field">
                    <label class="dip-label" for="dip-bank">Banco</label>
                    <select id="dip-bank" class="form-select" formControlName="bankCode">
                        <option value="">Selecciona tu banco</option>
                        <option *ngFor="let bank of banks" [value]="bank.code">{{ bank.name }}</option>
                    </select>
                </div>

                <div class="dip-field">
                    <label class="dip-label" for="dip-phone">Teléfono de pago móvil</label>
                    <input id="dip-phone" type="tel" class="form-control" formControlName="phone" placeholder="04141234567" autocomplete="tel" />
                    <div class="dip-error" *ngIf="phoneError">{{ phoneError }}</div>
                </div>

                <div class="dip-field">
                    <label class="dip-label" for="dip-cedula">Cédula del titular</label>
                    <input id="dip-cedula" type="text" class="form-control" formControlName="cedula" placeholder="V12345678" />
                    <div class="dip-error" *ngIf="cedulaError">{{ cedulaError }}</div>
                </div>

                <div class="dip-field">
                    <label class="dip-label" for="dip-holder">Nombre del titular</label>
                    <input id="dip-holder" type="text" class="form-control" formControlName="holderName" placeholder="Como aparece en tu banco" autocomplete="name" />
                </div>
            </form>

            <div class="dip-alert dip-alert--danger" *ngIf="tokenErrorDetail">Respuesta del banco: {{ tokenErrorDetail }}</div>

            <button type="button" class="dip-btn dip-btn--primary dip-btn--block" [disabled]="!canRequestToken" (click)="requestToken()">
                {{ requestingToken ? 'Pidiendo la clave…' : 'Continuar' }}
            </button>
            <div class="dip-hint">El banco te enviará una clave por mensaje para autorizar el pago.</div>
        </ng-container>

        <!-- Paso 2: la clave del banco. Vence 2 minutos después de pedirla, así que
             el contador manda: vencida, no se puede cobrar y hay que pedir otra. -->
        <ng-container *ngIf="step === 'otp'">
            <div class="dip-otp-intro">
                Enviamos una clave al <strong>{{ tokenSentTo || payingAccountLabel }}</strong
                >. Escríbela para autorizar el débito.
            </div>

            <ng-container *ngIf="!otpExpired">
                <div class="dip-otp-timer" [class.dip-otp-timer--urgent]="otpSecondsLeft <= 30">La clave vence en {{ otpCountdown }}</div>

                <form [formGroup]="otpForm" class="dip-form">
                    <div class="dip-field">
                        <label class="dip-label" for="dip-otp">Clave del banco</label>
                        <input id="dip-otp" type="text" inputmode="numeric" class="form-control dip-otp-input" formControlName="otp" placeholder="••••••" maxlength="8" autocomplete="one-time-code" />
                    </div>
                </form>

                <button type="button" class="dip-btn dip-btn--primary dip-btn--block" [disabled]="!canCharge" (click)="charge()">
                    {{ charging ? 'Procesando el pago…' : 'Pagar ' + (amountVES | number : '1.2-2') + ' Bs' }}
                </button>
                <button type="button" class="dip-btn dip-btn--ghost dip-btn--block" [disabled]="charging" (click)="goBackToAccountStep()">Volver</button>
            </ng-container>

            <ng-container *ngIf="otpExpired">
                <div class="dip-alert dip-alert--warning">
                    <div class="dip-alert__title">La clave venció</div>
                    <div>Tu banco la anula 2 minutos después de pedirla. Pide una nueva para autorizar el pago; no se debitó nada.</div>
                </div>

                <button type="button" class="dip-btn dip-btn--primary dip-btn--block" (click)="retryWithNewToken()">Pedir una clave nueva</button>
            </ng-container>
        </ng-container>

        <!-- Espera de la liquidación: el banco del cliente es de otra entidad y
             acepta primero, mueve el dinero después. El pago YA está registrado,
             así que esto es informativo: puede cerrar sin perder nada. -->
        <ng-container *ngIf="step === 'settling'">
            <div class="dip-settling">
                <span class="spinner-border spinner-border-sm" role="status"></span>
                <div class="dip-settling__body">
                    <div class="dip-settling__title">Confirmando con tu banco…</div>
                    <div class="dip-settling__text">Tu banco está procesando el débito. Registramos tu pago y te confirmamos en cuanto responda.</div>
                    <div class="dip-settling__timer">Esperamos hasta {{ settlementCountdown }}</div>
                    <div class="dip-settling__reference" *ngIf="settlementReference">Referencia: {{ settlementReference }}</div>
                </div>
            </div>
            <div class="dip-hint">Puedes cerrar esta ventana: tu pago ya quedó registrado y lo seguimos nosotros.</div>
        </ng-container>

        <!-- Paso 3: desenlace -->
        <ng-container *ngIf="step === 'result' && outcome">
            <div
                class="dip-alert"
                [class.dip-alert--success]="outcome.status === 'charged'"
                [class.dip-alert--danger]="outcome.status === 'rejected'"
                [class.dip-alert--warning]="outcome.status === 'indeterminate' || outcome.status === 'processing'"
            >
                <div class="dip-alert__title">{{ outcome.title }}</div>
                <div>{{ outcome.message }}</div>
                <div class="dip-alert__detail" *ngIf="outcomeBankDetail">Respuesta del banco: {{ outcomeBankDetail }}</div>
                <div class="dip-alert__detail" *ngIf="outcome.reference">Referencia: {{ outcome.reference }}</div>
            </div>

            <!-- Rechazo del banco: se puede reintentar. Si la clave se quemó, hace
                 falta pedir otra. -->
            <ng-container *ngIf="canRetryCharge">
                <button type="button" class="dip-btn dip-btn--primary dip-btn--block" *ngIf="outcome.requiresNewToken" (click)="retryWithNewToken()">Pedir una clave nueva</button>
                <button type="button" class="dip-btn dip-btn--primary dip-btn--block" *ngIf="!outcome.requiresNewToken" (click)="retryWithSameToken()">Intentar de nuevo</button>
            </ng-container>

            <!-- El dinero ya salió de la cuenta: nunca se ofrece pagar otra vez.
                 Acá no hay botón porque no hay nada que el cliente pueda hacer;
                 lo acredita soporte con la referencia. -->
            <div class="dip-hint" *ngIf="chargedNotRegistered">Tu banco ya debitó el monto. No pagues de nuevo: escríbenos con la referencia y lo acreditamos nosotros.</div>

            <div class="dip-hint" *ngIf="outcome.status === 'indeterminate' && !chargedNotRegistered">No vuelvas a pagar hasta confirmar si el débito se procesó. Revisa tu banco o escríbenos.</div>

            <!-- Pago registrado y en validación: no se ofrece pagar de nuevo,
                 porque ya hay un pago reportado por esta factura. -->
            <div class="dip-hint" *ngIf="paymentInReview">No hace falta que pagues de nuevo: tu pago está registrado y te avisamos cuando termine de validarse.</div>
        </ng-container>
    </div>
</ng-container>
